export default "__VITE_ASSET__C7OmOq2___"